export const TITLE_TOOLTIP_OPEN_DELAY = 500;
